import { useEffect, useRef } from "react";

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const MonthNavigation = ({ currentMonth, onMonthSelect }) => {
  const containerRef = useRef(null);
  const selectedButtonRef = useRef(null);
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;
  const nextYear = currentYear + 1;

  const handleYearClick = (year) => {
    const selectedDate = new Date(year, 0, 1);
    onMonthSelect?.(selectedDate);
  };

  const handleMonthClick = (year, monthIndex) => {
    const selectedDate = new Date(year, monthIndex, 1);
    onMonthSelect?.(selectedDate);
  };

  const isMonthCurrent = (year, monthIndex) => {
    const monthToCheck = currentMonth || new Date();
    return (
      monthToCheck.getMonth() === monthIndex &&
      monthToCheck.getFullYear() === year
    );
  };

  useEffect(() => {
    if (selectedButtonRef.current && containerRef.current) {
      const container = containerRef.current;
      const button = selectedButtonRef.current;

      const containerRect = container.getBoundingClientRect();
      const buttonRect = button.getBoundingClientRect();

      const scrollLeft =
        button.offsetLeft -
        container.offsetLeft -
        container.clientWidth / 2 +
        button.clientWidth / 2;

      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
    }
  }, [currentMonth]);

  return (
    <div
      ref={containerRef}
      className="flex items-center gap-2 overflow-x-auto pb-2"
    >
      <button
        onClick={() => handleYearClick(previousYear)}
        className="px-3 py-1.5 text-sm font-medium rounded-lg whitespace-nowrap transition-colors text-gray-600 hover:bg-gray-100"
      >
        {previousYear}
      </button>

      {monthNames.map((monthName, index) => {
        const isCurrent = isMonthCurrent(previousYear, index);

        return (
          <button
            key={`prev-${index}`}
            ref={isCurrent ? selectedButtonRef : null}
            onClick={() => handleMonthClick(previousYear, index)}
            className={`
              px-3 py-1.5 text-sm font-medium rounded-2xl whitespace-nowrap transition-colors
              ${
                isCurrent
                  ? "bg-gray-900 text-white"
                  : "text-gray-600 border border-gray-200 hover:bg-gray-100"
              }
            `}
          >
            {monthName}
          </button>
        );
      })}

      <button
        onClick={() => handleYearClick(currentYear)}
        className="px-3 py-1.5 text-sm font-medium rounded-lg whitespace-nowrap transition-colors text-gray-600 hover:bg-gray-100"
      >
        {currentYear}
      </button>

      {monthNames.map((monthName, index) => {
        const isCurrent = isMonthCurrent(currentYear, index);

        return (
          <button
            key={`current-${index}`}
            ref={isCurrent ? selectedButtonRef : null}
            onClick={() => handleMonthClick(currentYear, index)}
            className={`
              px-3 py-1.5 text-sm font-medium rounded-2xl whitespace-nowrap transition-colors
              ${
                isCurrent
                  ? "bg-gray-900 text-white"
                  : "text-gray-600 border border-gray-200 hover:bg-gray-100"
              }
            `}
          >
            {monthName}
          </button>
        );
      })}

      <button
        onClick={() => handleYearClick(nextYear)}
        className="px-3 py-1.5 text-sm font-medium rounded-lg whitespace-nowrap transition-colors text-gray-600 hover:bg-gray-100"
      >
        {nextYear}
      </button>

      {monthNames.map((monthName, index) => {
        const isCurrent = isMonthCurrent(nextYear, index);

        return (
          <button
            key={`next-${index}`}
            ref={isCurrent ? selectedButtonRef : null}
            onClick={() => handleMonthClick(nextYear, index)}
            className={`
              px-3 py-1.5 text-sm font-medium rounded-2xl whitespace-nowrap transition-colors
              ${
                isCurrent
                  ? "bg-gray-900 text-white"
                  : "text-gray-600 border border-gray-200 hover:bg-gray-100"
              }
            `}
          >
            {monthName}
          </button>
        );
      })}
    </div>
  );
};

export default MonthNavigation;
